import { lazy } from 'react'

export const Feed = lazy(() => import('./Feed'))
export const FeedAds =  lazy(() => import('./FeedAds'))
export const FeedContent =  lazy(() => import('./FeedContent'))
export const FeedMultitip =  lazy(() => import('./FeedMultitip'))
export const FeedPinnedContent =  lazy(() => import('./FeedPinnedContent'))
